import * as React from 'react';
import 'core-js/fn/object/assign';

const InlineData = props => {
    return (
        <div className="row form-group">
            <div className="col-md-2 col-sm-3 col-xs-3 input-group-text inline-data-label" style={{overflow:"hidden"}}>
                <label htmlFor={props.name}>{props.label}</label>
            </div>
            <div className="col-md-1 col-sm-1 col-xs-2 input-group-text inline-data-required" style={{overflow:"hidden"}}>
                {props.required &&
                        <img className="pull-right" style={{paddingBottom:"6px"}} src={window.baseUrl + "/img/big%20bell/icon_hissu.png"}/>
                }
            </div> 
            
            {setContainerType(props)}
            {props.description != null 
            ? 
            <div className="col-md-4 col-sm-12 col-xs-12 input-group-text" style={{whiteSpace:"pre-wrap",wordBreak:"break-word", textAlign:"left", fontSize:"11px"}}>
                {props.description}
            </div>
            :
            null}
        </div>
    );
};

function setContainerType(props){
    switch(props.containerType){
        case "text":
            return (
                <div className={props.inputClass !=null ? props.inputClass : (props.description != null ? "col-md-5 col-sm-7 col-xs-9":" col-md-9 col-sm-9")} >
                    <input type="text" maxLength={props.maxLength} autoComplete="off" disabled={props.disabled} className="form-control" name={props.name} placeholder={props.placeholder} value={props.value} onChange={e => props.onChange(e.target.value)} style={props.style}/>
                </div>
            );
    
    case "select":
        return (
            <div className={props.inputClass !=null ? props.inputClass : (props.description != null ? "col-md-5 col-sm-7 col-xs-9":" col-md-9 col-sm-9")} >
                <select disabled={props.disabled} className="multiselect dropdown-toggle input-group-text col-md-9 col-xs-12" name={props.name} value={props.value} style={{textAlign:"left"}}
                    onChange={e => props.onChange(e.target.value)}>
                    {props.options && 
                        props.options.map(function(option, index) {
                            return <option key={index} value={option.value}>{option.label}</option>
                        })
                    }
                </select>
            </div>
        );
    
    default:
        return (
            <div className={ props.inputClass != null? props.inputClass : (props.description != null ? "col-md-5 col-sm-7 col-xs-9 input-group-text" : "col-md-9 col-sm-9 input-group-text") } style={props.style != null ? props.style : {paddingLeft:"15px"}}>
                <label name={props.name} onChange={e => props.onChange(e.target.value)}>{props.value}</label>
            </div>
        );
    
  }
}

export default InlineData;


// WEBPACK FOOTER //
// ./components/forms/inlinedata/index.jsx